import React, { PropTypes, Component } from 'react'
import { formatDate } from 'utils/dates'
import moment from 'moment-timezone'

import './AliadaProfileAvailabilityHeader.scss'

class AliadaProfileAvailabilityHeader extends Component {
  constructor (props) {
    super(props)
    this.prevHandler = this.prevHandler.bind(this)
    this.nextHandler = this.nextHandler.bind(this)
  }

  prevHandler () {
    this.props.onPageChange(this.props.page - 1)
  }

  nextHandler () {
    this.props.onPageChange(this.props.page + 1)
  }

  dateRange ({ page, daysPerPage, availability }) {
    if (daysPerPage === 1) {
      return [ availability[page].date ]
    }

    const lowerIndex = page * daysPerPage
    const lowerKey = Object.keys(availability)[lowerIndex]
    const lowerDate = availability[lowerKey].date
    const upperDate = moment(lowerDate).add(daysPerPage - 1, 'days')

    return [ lowerDate, upperDate ]
  }

  formattedDateRange ({ page, daysPerPage, availability }) {
    const format = momentDate => formatDate('dddd D [de] MMMM', momentDate)
    const formattedDates = this.dateRange({ page, daysPerPage, availability }).map(format)
    return formattedDates.join(' al ')
  }

  render () {
    const {
      page,
      availability,
      daysPerPage
    } = this.props

    let maxPage = Math.ceil(Object.keys(availability).length / daysPerPage) - 1

    let prevEnabled = page > 0
    let nextEnabled = page < maxPage

    return (
      <div className='AliadaProfileAvailabilityHeader'>
        {prevEnabled && (
          <button
            className='AliadaProfileAvailabilityHeader-prevButton'
            onClick={this.prevHandler}
            >
            <span className='icon-chevron-left' />
          </button>
        )}

        <p className='AliadaProfileAvailabilityHeader-dates'>
          Disponibilidad del
          <span>{this.formattedDateRange(this.props)}</span>
        </p>

        {nextEnabled && (
          <button
            className='AliadaProfileAvailabilityHeader-nextButton'
            onClick={this.nextHandler}
            >
            <span className='icon-chevron-right' />
          </button>
        )}
      </div>
    )
  }
}

AliadaProfileAvailabilityHeader.displayName = 'AliadaProfileAvailabilityHeader'
AliadaProfileAvailabilityHeader.propTypes = {
  availability: PropTypes.object.isRequired,
  page: PropTypes.number.isRequired,
  daysPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
}
AliadaProfileAvailabilityHeader.defaultProps = {}

export default AliadaProfileAvailabilityHeader



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/AliadaProfile/components/AliadaProfileAvailability/components/AliadaProfileAvailabilityHeader/AliadaProfileAvailabilityHeader.js